import Text from './Text';
import {IProps as ITextProps} from './Text';

interface IProps extends ITextProps {
  width?: string;
}

export default function SingleText({
  width = '100%',
  className,
  style,
  ...rest
}: IProps) {
  return (
    <Text
      className={cn(
        'overflow-hidden text-ellipsis !whitespace-nowrap',
        className
      )}
      style={{...style, width}}
      {...rest}
    />
  );
}
